<script>
import RescheduleAppointmentForm from '@satellite/modules/appointments/components/reschedule/RescheduleAppointmentForm';

export default {
  name: 'RescheduleAppointmentForm',
  extends: RescheduleAppointmentForm,
  methods: {
    async getLoadTypeSettings() {
      let settings = {};

      const res = await axios.get(`/loadtype/${this.appointment.loadTypeId}`);
      if (res?.data?.data) {
        settings = res.data.data.settings || {};
      }

      return settings;
    },
    async setAllowDockSelection() {
      const loadTypeSettings = await this.getLoadTypeSettings();
      this.allowDockSelect = loadTypeSettings.allowCarrierDockSelection;
    },
    setSelectedDock() {
      // This is very important, it asks for availability
      // for multiple docks to make sure it can
      // be scheduled
      if (!this.allowDockSelect) {
        this.selectedDock = this.appointmentWarehouse.docks?.filter(dock => {
          return dock.loadTypeIds.includes(this.appointment.loadTypeId);
        });
      } else {
        this.selectedDock = this.appointment.dock;
      }
    }
  },
  async beforeMount() {
    await this.setAllowDockSelection();
  },
  watch: {
    async allowDockSelect() {
      this.setSelectedDock();
    },
    async appointmentWarehouse() {
      this.setSelectedDock();
    }
  }
};
</script>
